import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Card, CardContent, FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { themeActions } from '../../../_actions/theme.actions';
import _ from 'lodash';
import ColorPicker from '../../ColorPicker';
import { PLATFORMS, TRAY_LIKE_PLATFORMS, NUVEM_PRODUCT_SORT_OPTIONS, TRAY_PRODUCT_SORT_OPTIONS, WIX_PRODUCT_SORT_OPTIONS, IRROBA_PRODUCT_SORT_OPTIONS } from '../../../_helpers/constants';
import { storeActions } from '../../../_actions/store.actions';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  contentTitle: {
    padding: '10px 15px'
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  firstFormControl: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  }
}));

export default function CategorySettings({ data }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const platform = useSelector(state => state.StoreReducer.platform);
  const categoryOrder = useSelector(state => state.StoreReducer.categoryOrder);

  let sortOptions = []

  switch(platform){
    case PLATFORMS.BAGY:
    case PLATFORMS.TRAY:
      sortOptions = TRAY_PRODUCT_SORT_OPTIONS()
      break;
    case PLATFORMS.NUVEMSHOP:
      sortOptions = NUVEM_PRODUCT_SORT_OPTIONS;
      break;
    case PLATFORMS.WIX:
      sortOptions = WIX_PRODUCT_SORT_OPTIONS;
      break;
    case PLATFORMS.IRROBA:
      sortOptions = IRROBA_PRODUCT_SORT_OPTIONS;
      break;
    default:
      break;
  }

  const getSortOptionHelperText = () => {
    const sortOption = sortOptions.find(opt => opt.value === data.options.defaultSorting);

    if(!!sortOption) {
      return sortOption.helperText;
    }

    return '';
  }

  const handleChange = (property, value) => {
    let newData = JSON.parse(JSON.stringify(data));
    _.set(newData, property, value)
    dispatch(themeActions.setSelectedSection(newData));
  }

  const handleChangeCategoryOrder = (categoryOrder) => {
    dispatch(storeActions.setCategoryOrder(categoryOrder))
  }

  return (
    <main className={classes.content}>
        <Typography variant="overline" display="block" className={classes.contentTitle}>
            Configurações
        </Typography>
        
        <Card elevation={1} square>
          <CardContent>

            <ColorPicker
              label='Cor do título da categoria'
              initialColor={_.get(data, 'options.titleFontColor', '#ffffff')}
              onChange={(color) => handleChange('options.titleFontColor', color)}
            />

            <ColorPicker
              label='Cor de fundo do título da categoria'
              initialColor={_.get(data, 'options.titleBackgroundColor', '#000000')}
              onChange={(color) => handleChange('options.titleBackgroundColor', color)}
            />

            <FormControl fullWidth className={classes.firstFormControl}>
                <InputLabel>Ordenação dos nomes das categorias</InputLabel>
                <Select
                    native
                    value={categoryOrder ?? 'default'}
                    onChange={(e) => handleChangeCategoryOrder(e.target.value)}
                    label="Ordenação padrão"
                >
                    <option value={'asc'}>A-Z</option>
                    <option value={'desc'}>Z-A</option>
                    <option value={'default'}>Padrão da plataforma</option>
                </Select>
                <FormHelperText>{getSortOptionHelperText()}</FormHelperText>
                <FormHelperText>Selecione como devem ser ordenados os nomes das categorias</FormHelperText>
            </FormControl>

            <FormControl fullWidth className={classes.formControl}>
                <InputLabel>Ordenação padrão dos produtos</InputLabel>
                <Select
                    native
                    value={data.options.defaultSorting}
                    onChange={(e) => handleChange('options.defaultSorting', e.target.value)}
                    label="Ordenação padrão"
                >
                  {sortOptions.map((sortOption, index) => {
                    return <option key={`so=${index}`} value={sortOption.value}>{sortOption.label}</option>
                  })}
                </Select>
                <FormHelperText>{getSortOptionHelperText()}</FormHelperText>
                <FormHelperText>Selecione como devem ser ordenados os produtos dentro de uma categoria</FormHelperText>
            </FormControl>

            <FormControl fullWidth className={classes.formControl}>
                <InputLabel>Visualização padrão dos produtos</InputLabel>
                <Select
                    native
                    value={data.options.defaultView}
                    onChange={(e) => handleChange('options.defaultView', e.target.value)}
                    label="Visualização padrão"
                >
                    <option value='grid'>Grid</option>
                    <option value='list'>Lista</option>
                </Select>
              <FormHelperText>Escolha se os cards de produtos devem ser exibidos em grid ou em lista</FormHelperText>
            </FormControl>
          </CardContent>
        </Card>
    </main>
  );
}